import '@/components/dashboard/dashboard.css';
import { useSearchParams } from 'react-router-dom';
import { DashboardWrapper } from './dashboard/DashboardWrapper';
import { DashboardMainContent } from './dashboard/DashboardContent';

// Export sample data for use in other files
export { SAMPLE_VIDEOS } from './dashboard/sampleData';

export default function MyVideos() {
  const [searchParams] = useSearchParams();
  const folderId = searchParams.get('folderId');

  return (
    <DashboardWrapper>
      <DashboardMainContent folderId={folderId} />
    </DashboardWrapper>
  );
}
